declare const I18n;

import * as React from "react";
import { UberTable, RowDefinition } from "./UberTable";

export type LearnersCourseProgressRow = {
  learner_id: number;
  learner_name: string;
  course_id: number;
  course_title: string;
  course_progress: number;
  current_active_lesson: string | null;
  quiz_attempts: number | null;
};

type Props = {};

class LearnersCourseProgressTable extends React.Component<Props> {
  private rowDefinition: RowDefinition<LearnersCourseProgressRow>[];

  constructor(props: Props) {
    super(props);

    this.rowDefinition = [
      {
        title: I18n.t("models.common.name"),
        attribute_key: "learner_name",
        sort_key: "name",
        render: (row: LearnersCourseProgressRow) => (
          <a href={`/learners/${row.learner_id}/edit`}>
            {row.learner_name}
          </a>
        ),
      },
      {
        title: I18n.t("views.learners.index.tables.course_title"),
        attribute_key: "course_title",
        sort_key: "course_title",
        render: (row: LearnersCourseProgressRow) => (
          <a href={`/courses/${row.course_id}/lessons`}>
            {row.course_title}
          </a>),
      },
      {
        title: I18n.t("views.learners.index.tables.course_progress"),
        attribute_key: "course_progress",
        sort_key: "course_progress",
        textAlignment: "center",
        render: (row: LearnersCourseProgressRow) => {
          return `${row.course_progress}%`;
        },
      },

      {
        title: I18n.t("views.learners.index.tables.current_active_lesson"),
        attribute_key: "current_active_lesson",
        sort_key: "current_active_lesson",
        render: (row: LearnersCourseProgressRow) => {
          return row.current_active_lesson ?? "—";
        },
      },
      {
        title: I18n.t("views.learners.index.tables.quiz_attempts"),
        attribute_key: "quiz_attempts",
        sort_key: "quiz_attempts",
        textAlignment: "center",
        render: (row: LearnersCourseProgressRow) => {
          return row.quiz_attempts ?? 0;
        },
      },
    ];
  }

  render() {
    return (
      <UberTable<LearnersCourseProgressRow>
        rowDefinition={this.rowDefinition}
        searchType="learners-course-progress"
        omitOptions={true}
        {...this.props}
      />
    );
  }
}

export default LearnersCourseProgressTable;
